/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type removeCollaboratorModal_collaborator$ref: FragmentReference;
declare export opaque type removeCollaboratorModal_collaborator$fragmentType: removeCollaboratorModal_collaborator$ref;
export type removeCollaboratorModal_collaborator = {|
  +id: string,
  +rowId: any,
  +email: string,
  +name: string,
  +teams: {|
    +totalCount: number,
    +nodes: $ReadOnlyArray<?{|
      +id: string,
      +name: string,
    |}>,
  |},
  +$refType: removeCollaboratorModal_collaborator$ref,
|};
export type removeCollaboratorModal_collaborator$data = removeCollaboratorModal_collaborator;
export type removeCollaboratorModal_collaborator$key = {
  +$data?: removeCollaboratorModal_collaborator$data,
  +$fragmentRefs: removeCollaboratorModal_collaborator$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": {},
      "kind": "LocalArgument",
      "name": "teamFilter",
      "type": "TeamFilter"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "removeCollaboratorModal_collaborator",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rowId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    (v1/*: any*/),
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "filter",
          "variableName": "teamFilter"
        }
      ],
      "concreteType": "TeamsConnection",
      "kind": "LinkedField",
      "name": "teams",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Team",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User"
};
})();
// prettier-ignore
(node/*: any*/).hash = 'df3fd0ae10dc9556655fc78a45b378bf';

module.exports = node;
